<template>
    <div class="campaign-option">
        <div class="campaign-option--title">
            Loan Size
            <info-tooltip text="Select the loan sizes you wish to apply to this ad set. <br>Conforming and jumbo loan sizes are defined on a market level."></info-tooltip>
        </div>

        <div class="campaign-adset-location__input">
            <multiselect
                v-model="selectedLoanSizes"
                :multiple="true"
                :options="loanSizes"
                label="label"
                :close-on-select="false"
                :hide-selected="true"
                track-by="id"
                :placeholder="placeholder"
                :show-labels="false">
            </multiselect>
        </div>

        <div v-show="showOptInConformingLimit" class="opt-in-conforming" :class="disableOptInConformingLimit ? 'disabled' : ''">
            <label>
                <input type="checkbox" v-model="optInNewConformingLimitValue" :disabled="disableOptInConformingLimit"> Opt-in New Conforming Limit
            </label>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import find from "lodash/find";

    export default {
        components: { Multiselect },

        props: {
            value: Array,
            loanSizes: Array,
            optInNewConformingLimit: Boolean
        },

        data() {
            return {
                selectedLoanSizes: this.value,
                optInNewConformingLimitValue: this.optInNewConformingLimit
            }
        },

        mounted() {
            if (this.selectedLoanSizes.length === 0) {
                this.selectAllLoanSizesBecauseNoneAreSelected();
            }
        },

        watch: {
            selectedLoanSizes(loanSizes) {
                if (loanSizes.length === 0) {
                    this.selectAllLoanSizesBecauseNoneAreSelected();
                } else {
                    this.$emit('input', loanSizes);
                }

                if (find(this.selectedLoanSizes, { label: 'Jumbo' }) || loanSizes.length === 0) {
                    this.optInNewConformingLimitValue = false;
                }
            },

            optInNewConformingLimitValue(value) {
                this.$emit('setOptInNewConformingLimit', value);
            }
        },

        computed: {
            placeholder() {
                if (this.selectedLoanSizes.length === 0) {
                    return 'All Loan Sizes';
                } else if (this.selectedLoanSizes.length === this.loanSizes.length) {
                    return '';
                } else {
                    return 'Select Loan Size';
                }
            },

            showOptInConformingLimit() {
                return this.featureFlag('opt-in-new-conforming-limit-enabled');
            },

            disableOptInConformingLimit() {
                return find(this.selectedLoanSizes, { label: 'Jumbo' }) || this.selectedLoanSizes.length === 0;
            }
        },

        methods: {
            selectAllLoanSizesBecauseNoneAreSelected() {
                this.$emit('input', this.loanSizes);
            }
        }
    }
</script>

<style scoped>
.opt-in-conforming {
    margin-top: 10px;
}

.opt-in-conforming label {
    font-weight: normal;
}

.disabled {
    color: #ababab;
}
</style>
